(function () {
    window.addEventListener('DOMContentLoaded', (event) => {
        initWK();
        let wkInitCheck = setInterval(function () {
            let statusWrapperEl = document.querySelector(".wk-account-status-wrapper");
            if (statusWrapperEl) {
                let statusWrapperActiveEl = document.querySelector(".wk-account-status-wrapper.wk-action-active");
                if (statusWrapperActiveEl) {
                    clearInterval(wkInitCheck);
                } else {
                    initWK();
                }
            } else {
                clearInterval(wkInitCheck);
            }
        }, 5000);
    });

    const eventTicketBuyBtns = document.querySelectorAll('.ticket-buy-btn');
    if ( eventTicketBuyBtns && eventTicketBuyBtns.length ) {
        eventTicketBuyBtns.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                const eventId = btn.dataset.id;

                wkModal(`tickets?id=${eventId}`);
                // window.wk.modal(`tickets?id=${eventId}`);
            });
        });
    }

    /** Wallkit click actions by class wk-actions selectors */
    document.addEventListener('click', function(e){
        if ( e.target ) {
            if ( e.target.classList.contains('wk-action-checkout-w-data') && e.target.dataset.plan_id>0 ) {
                e.preventDefault();
                wkModal(`checkout?[{"item_type":"subscription","item_key":"${e.target.dataset.plan_id}"}]`);
                // window.wk.modal(`checkout?[{"item_type":"subscription","item_key":"${e.target.dataset.plan_id}"}]`);
            } else if ( e.target.classList.contains('wk-action-account-button') || ifParentHasClass(e.target, 'wk-action-account-button') ) {
                e.preventDefault();
                if (window.wk.authentication.isAuthenticated()) {
                    wkModal('account-settings');
                    // window.wk.modal('account-settings', {'lang': window.wkAppVars.lang});
                } else {
                    window.wk.authentication.show();
                }
            }
        }
    });

    function ifParentHasClass(element, classname) {
        if (element && element.classList && element.classList.contains(classname)) {
            return true;
        }
        return element.parentNode && ifParentHasClass(element.parentNode, classname);
    }

    function getCurrentLanguage() {
        const currentLanguageElement = document.querySelector('.current-language');
        if (currentLanguageElement && currentLanguageElement.dataset.id) {
            return Number(currentLanguageElement.dataset.id);
        }

        return 1;
    }

    function initWK() {
        const modalContent = document.createElement('div');
        modalContent.classList.add('wk-popup-auth-pro');

        modalContent.insertAdjacentHTML('beforeend', `
       <div>
  <div class="wk-auth-header">
    <img src="/wp-content/themes/retaildetail/assets/sources/images/logo.svg" alt="RetailDetail">
  </div>
  <div class="wk-auth-content">
    <div class="wk-auth-content-center">
      <div id="wk-fp-auth-wrapper"></div>
    </div>
  </div>
</div>
        `);

        let WallkitInitOptions = {
            lang: window.wkAppVars.lang,
            public_key: window.wkAppVars.config.wk_public_key,
            mode: window.wkAppVars.config.wk_mode,
            version: window.wkAppVars.config.wk_version,
            auth: {
                firebase: {
                    config: {
                        apiKey: window.wkAppVars.config.wk_fb_api_key,
                        authDomain: window.wkAppVars.config.wk_fb_auth_domain,
                        projectId: window.wkAppVars.config.wk_fb_project_id,
                        storageBucket: window.wkAppVars.config.wk_fb_storage_bucket,
                        messagingSenderId: window.wkAppVars.config.wk_fb_messaging_sender_id,
                        appId: window.wkAppVars.config.wk_fb_app_id
                    },
                    providers: [
                        {
                            provider: 'email',
                            buttonColor: '#E93530',
                            fullLabel: window.wkAppVars.fb_email_flabel // 'Continue with Email'
                        },
                        {
                            provider: 'google',
                            fullLabel: window.wkAppVars.fb_google_flabel // 'Continue with Google'
                        }
                    ],
                    elementSelector: '#wk-fp-auth-wrapper',
                    tosURL: window.wkAppVars.tosURL[window.wkAppVars.lang],
                    privacyPolicyURL: window.wkAppVars.privacyPolicyURL[window.wkAppVars.lang]
                },
                modal: {
                    content: modalContent
                },
            },
            analytics: {
                parseUTM: true // default true
            },
            onInit: () => {

            }
        };

        window.wk = new WallkitIntegration(WallkitInitOptions);

        if (typeof window.wkFirebaseEmailLabel === "undefined") {
            window.wkFirebaseEmailLabel = setInterval(function () {
                let wkFirebaseEmailLabelEl = document.querySelector(".firebaseui-label[for=email]");
                if (wkFirebaseEmailLabelEl) {
                    if (wkFirebaseEmailLabelEl.innerText === 'Email') {
                        wkFirebaseEmailLabelEl.innerText = window.wkAppVars.work_email; //'Work Email'
                    }
                }
            }, 100);
        }

        let wkAuthReady = setInterval(function () {
            if (window.wk.authentication) {
                clearInterval(wkAuthReady);
                wkShowUserStatus();
                wkCheckPostAccess();
                wkCheckAddressBar();
                wkShowPromo();
                wkAddLinkActions();
            }
        }, 100);

        window.wk.events.subscribe("success-auth", function ({register}) {
            if (register) {
                window.wk.sdk.methods.updateUser({
                    language_id: getCurrentLanguage()
                }).catch((error) => {
                   console.log('LANGUAGE SET ERROR', error);
                });
            }

            wkShowUserStatus();
            window.wk.popup.hide();
            wkCheckPostAccess();
        });

        window.wk.events.subscribe("wk-event-logout", function () {
            wkShowUserStatus();
            wkCheckPostAccess();
        });
    }

    function wkAddLinkActions() {
        const statusWrapperEls = document.querySelectorAll(".wk-account-status");
        if (statusWrapperEls) {
            statusWrapperEls.forEach(element => {
                element.classList.add('wk-action-active');
            });
        }
    }

    function wkShowUserStatus() {
        const imgDefaultSrc = '/wp-content/themes/retaildetail/assets/sources/images/user_avatar.svg';
        const accountStatusSpanEls = document.querySelectorAll(".wk-account-status .wk-status-label span");
        const accountStatusImgEls = document.querySelectorAll(".wk-account-status .wk-status-label img");
        if (window.wk.authentication.isAuthenticated()) {
            window.wk.sdk.methods.client.get({
                path: '/user'
            })
                .then((responce) => {
                    if (responce.id > 0 && responce.id === window.wk.sdk.methods.user.id) {
                        window.wk.sdk.methods.user = responce;
                        accountStatusImgEls.forEach(element => {
                            element.src = window.wk.sdk.methods.user.photos.image_100;
                        });
                        accountStatusSpanEls.forEach(element => {
                            element.innerHTML = `${window.wk.sdk.methods.user.first_name} ${window.wk.sdk.methods.user.last_name}`.trim(); // My&nbsp;Account
                        });
                        checkStatusPurchaseButtons(true, window.wk.sdk.methods.user);
                        checkStatusBannerRedPlus();
                    }
                }, (error) => {
                    console.log('ERROR:', error);
                });
        } else {
            accountStatusImgEls.forEach(element => {
                element.src = imgDefaultSrc;
            });
            accountStatusSpanEls.forEach(element => {
                element.innerHTML = window.wkAppVars.sign_id; // Sign&nbsp;in
            });

            checkStatusPurchaseButtons(false, false);
            checkStatusBannerRedPlus();
        }
    }

    function wkCheckPostAccess() {
        if (typeof window.wkPostData !== "undefined"
            && typeof window.wkPostData.id !== "undefined"
            && window.wkPostData.id !== '') {
            const postInfo = window.wkPostData;
            const wkPost = new window.wk.content(postInfo);
            const postContentWrapper = document.querySelector(".single-post .main-container .article-column article");
            if (window.wkAppVars.wp_is_auth) {
                if (postContentWrapper) {
                    postContentWrapper.classList.add('wk-content-active');
                }
                return;
            }
            wkPost.checkAccess().then((response) => {

                if (!response.allowed) {
                    let wkContentAfterEls = document.querySelectorAll(".single-post .main-container .article-column article > *");
                    showWKPaywall(wkContentAfterEls[2]);
                    if (postContentWrapper) {
                        postContentWrapper.classList.add('wk-content-paywall');
                    }
                } else {
                    if (postContentWrapper) {
                        postContentWrapper.classList.remove('wk-content-paywall');
                    }
                    let wkPaywallBlock = document.querySelector(".wk-paywall-block");
                    if (wkPaywallBlock) {
                        wkPaywallBlock.parentNode.removeChild(wkPaywallBlock);
                    }
                }
                if (postContentWrapper) {
                    postContentWrapper.classList.add('wk-content-active');
                }
            }).catch((error) => {
                console.log('!! wkPost ERROR', error);
            });
        }
    }

    function showWKPaywall(contentNode) {
        const paywallBlockContent = document.createElement('div');
        paywallBlockContent.classList.add('wk-paywall-block');
        if (window.wk.authentication && wk.sdk.methods.user ) {
            paywallBlockContent.insertAdjacentHTML('beforeend', `
<div class="wk-paywall-block-content">
<h3 class="wk-paywall-block-title">
${window.wkAppVars.paywall_buy_title}
</h3>
<p class="wk-paywall-block-description">${window.wkAppVars.paywall_buy_description}</p>
<div class="wk-paywall-block-buttons-wrapper">
<a href="/subscribe" class="wk-paywall-block-register-button">${window.wkAppVars.pricing}</a>
</div>
</div>
        `);
        } else {
            paywallBlockContent.insertAdjacentHTML('beforeend', `
<div class="wk-paywall-block-content">
<h3 class="wk-paywall-block-title">
${window.wkAppVars.paywall_subscribe_title}
</h3>
<p class="wk-paywall-block-description">${window.wkAppVars.paywall_subscribe_description}</p>
<div class="wk-paywall-block-buttons-wrapper">
<a href="#" class="wk-paywall-block-register-button" onclick="wkModal('account-settings'); return false;">${window.wkAppVars.paywall_btn_login}</a>
<span>${window.wkAppVars.or}</span>
<a href="#" class="wk-paywall-block-register-button white" onclick="wkModal('account-settings'); return false;">${window.wkAppVars.paywall_btn_register}</a>
</div>

</div>
        `);
        }

        contentNode.parentNode.insertBefore(paywallBlockContent, contentNode.nextSibling);
    }
    
    function wkCheckAddressBar() {
        let hash = window.location.hash;

        if (hash === "#firsttimelogin") {
            history.pushState({}, document.title, window.location.pathname);
            window.wk.authentication.show();
        }
    }

    /**
     * Check visibility red plus banner for paid members
     */
    function checkStatusBannerRedPlus() {
        const wkBannerRedPlus = document.querySelectorAll(".wk-banner-red-plus");
        if (wkBannerRedPlus) {
            if (window.wk.authentication.isAuthenticated()
                && window.wk.sdk.methods.user.subscriptions
                && window.wk.sdk.methods.user.subscriptions[0].price > 0) {
                wkBannerRedPlus.forEach(element => {
                    element.style.display = 'none';
                });
            } else {
                wkBannerRedPlus.forEach(element => {
                    element.style.display = 'block';
                });
            }
        }
    }

    /**
     * Check user status and subscription plan and add some logic for subscription page
     * @param is_authenticated
     * @param user
     */
    function checkStatusPurchaseButtons(is_authenticated, user) {

        const accountStatusSubscribeButton = document.querySelectorAll(".wk-account-status .member");
        const memberSunscriptionButtons = document.querySelectorAll(".plans .subscribe-button");

        if ( is_authenticated ) {
            if ( user.subscriptions && user.subscriptions[0].plan.slug) {
                let hide_subscription_buttons = [window.wkAppVars.wk_plan_ids[user.subscriptions[0].plan.slug]];
                switch (user.subscriptions[0].plan.slug) {
                    case 'hyper':
                        hide_subscription_buttons.push(window.wkAppVars.wk_plan_ids['super']);
                    case 'super':
                        hide_subscription_buttons.push(window.wkAppVars.wk_plan_ids['compact']);
                    case 'compact':
                        memberSunscriptionButtons.forEach(element => {
                            if (!element.id || parseInt(element.id) === parseInt(user.subscriptions[0].id) || hide_subscription_buttons.includes(parseInt(element.id))) {
                                element.innerHTML = window.wkAppVars.my_account;
                                element.classList.remove('wk-action-checkout-w-data');
                                element.classList.add('wk-action-account-button');
                            } else {
                                element.innerHTML = window.wkAppVars.button_title_subscribe;
                                element.classList.add('wk-action-checkout-w-data');
                                element.classList.remove('wk-action-account-button');
                            }
                        });
                        break;
                    case 'freemium':
                        memberSunscriptionButtons.forEach(element => {
                            if (element.id>0) {
                                element.innerHTML = window.wkAppVars.button_title_subscribe;
                                element.classList.add('wk-action-checkout-w-data');
                                element.classList.remove('wk-action-account-button');
                            } else {
                                element.innerHTML = window.wkAppVars.my_account;
                                element.classList.remove('wk-action-checkout-w-data');
                                element.classList.add('wk-action-account-button');
                            }
                        });
                        return;
                    case 'guest':
                        memberSunscriptionButtons.forEach(element => {
                            element.innerHTML = window.wkAppVars.button_title_subscribe;
                            if (element.id>0) {
                                element.classList.add('wk-action-checkout-w-data');
                            }
                            element.classList.remove('wk-action-account-button');
                        });
                        return;
                }
                accountStatusSubscribeButton.forEach(element => {
                    element.style.display = 'none';
                });
            }
        } else {
            accountStatusSubscribeButton.forEach(element => {
                element.style.display = 'initial';
            });
            memberSunscriptionButtons.forEach(element => {
                element.innerHTML = window.wkAppVars.button_title_subscribe;
                if (element.id>0) {
                    element.classList.add('wk-action-checkout-w-data');
                }
            });
        }
    }

    function wkShowPromo() {
        // if (!window.wk.authentication.isAuthenticated()) {
        //     let is_wk_promo_popup_shown_guest = wkGetCookie("is_wk_promo_popup_shown_guest");
        //     if (is_wk_promo_popup_shown_guest === null) {
        //         setTimeout(function () {
        //             wkSetCookie('is_wk_promo_popup_shown_guest', 1, 1);
        //
        //             // add some promo modal code here
        //
        //         }, 5000);
        //     }
        // }
    }

    window.wkModal = function(name) {
        window.wk.modal(name, {'lang': window.wkAppVars.lang});
    }

    function wkGetCookie(key) {
        var name = key + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    }

    function wkSetCookie(key, value, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = key + "=" + value + ";" + expires + ";path=/";
    }
})();